import axios, { AxiosResponse } from "axios";
import { IResponse } from "../models/General";
import { StudyEvaluationParam, HistoryParam, ProgramGenerateParam, GenerateSPParam, GenerateLogParam } from "../models/StudyEvaluation";
import { StudentAttendanceParam, StudentAttendanceDetailParam,LecturerAttendanceParam,StudentAbsenceMaxParam } from "../models/Attendance";
import { ObeParam,ClassListParam } from "../models/Obe";
import { NotEnrolledParam } from "../models/NotEnrolled";
import { request } from "http";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.interceptors.request.use(
    config => {
        const token = window.localStorage.getItem('token');
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);


axios.interceptors.response.use(undefined, error => {
    if (error.message === 'Network Error' && !error.response) {
       //alert('Network error - make sure API is running!')
        //window.location.reload();
    }

    const { status, data, config, headers } = error.response;
    
    if (status === 404) {
        alert('Not found')
        // window.location.reload();
    }

    if (status === 401) {
        alert("Your session has expired, please login again");
        window.localStorage.removeItem('token');
        // window.location.reload();
    }

    if (status === 400 && config.method === 'get' && data.errors.hasOwnProperty('id')) {
        alert('Data not found');
        // window.location.reload();
    }

    if (status === 500) {
        alert('Server error - check the terminal for more info!')
    }

    throw error.response;
});


const responseBody = (response: AxiosResponse) => response.data;

const requests = {
    get: (url: string) => axios.get(url).then(responseBody),
    post: (url: string, body: {}) => axios.post(url,body).then(responseBody),
    put: (url: string, body: {}) => axios.put(url,body).then(responseBody),
    del: (url: string) => axios.delete(url).then(responseBody)
}

const StudyEvaluation = {
    processList:(param: StudyEvaluationParam): Promise<IResponse> => requests.post('/academic/evaluation-process/search',param),
    processApproval:(param: any): Promise<IResponse> => requests.post('/academic/evaluation-process/approval',param),
    historyList:(param: HistoryParam): Promise<IResponse> => requests.post('/academic/history/search',param),
    historyDetail:(history_id: number): Promise<IResponse> => requests.get(`/academic/history/detail/${history_id}`),
    programGenerateList:(param: ProgramGenerateParam): Promise<IResponse> => requests.post('/academic/generate/programsp',param),
    generateSP:(param: GenerateSPParam): Promise<IResponse> => requests.post('/academic/generate/save',param),
    generateLog:(param: GenerateLogParam): Promise<IResponse> => requests.post('/academic/generate/search',param),
    getDiffGpa:(param: any): Promise<IResponse> => requests.post('/academic/evaluation-process/get-diff-gpa',param),
}

const StudentAttendance = {
    studentAttendanceList:(param: StudentAttendanceParam): Promise<IResponse> => requests.post('/academic/attendance/search',param),
    StudentAttendanceListDetail:(param: StudentAttendanceDetailParam): Promise<IResponse> => requests.post('/academic/attendance/search-detail',param),
    createdDate:(institution: string, strm: string): Promise<IResponse> => requests.get(`/academic/attendance/created-date/${institution}/${strm}`),
    processUpdateCallStatus:(param: any): Promise<IResponse> => requests.post('/academic/attendance/update-call-status',param),
    callReason:(): Promise<IResponse> => requests.get(`/academic/attendance/call-reason/`),
    studentAbsenceMaxList:(param: StudentAbsenceMaxParam): Promise<IResponse> => requests.post('/academic/attendance/search-student-max',param),
    absenceType:(): Promise<IResponse> => requests.get(`/academic/attendance/absence-type/`),

}

const LecturerAttendance = {
    lecturerAttendanceList:(param: LecturerAttendanceParam): Promise<IResponse> => requests.post('/academic/attendance/search-lecturer',param),
}

const Obe = {
    gradeList:(param: ObeParam): Promise<IResponse> => requests.post('/academic/obe/get-grade-detail-question',param),
    classList:(param:ClassListParam): Promise<IResponse> => requests.post(`/academic/obe/get-lecturer-class-list`,param),
    columnList:(param: ObeParam): Promise<IResponse> => requests.get(`/academic/obe/get-grade-detail-question-column/${param.STRM}/${param.CLASS_NBR}/${param.COMP_SEQUENCE_NO}`),
    examList:(strm:string, class_nbr:number): Promise<IResponse> => requests.get(`academic/obe/get-lam-class/${strm}/${class_nbr}`),
    mergeGradeDetail:(param: any): Promise<IResponse> => requests.post('/academic/obe/merge-grade-detail',param),
    examTypeDesc:(param: ObeParam): Promise<IResponse> => requests.get(`academic/obe/get-exam-type-desc/${param.STRM}/${param.CLASS_NBR}/${param.COMP_SEQUENCE_NO}`),
    recapTable:(strm:string, class_nbr:string,emplid:string): Promise<IResponse> => requests.get(`academic/obe/get-calculated-recap-table/${strm}/${class_nbr}/${emplid}`),
    chart100:(param: ObeParam): Promise<IResponse> => requests.get(`/academic/obe/get-calculated-scale100-graph/${param.STRM}/${param.CLASS_NBR}/${param.COMP_SEQUENCE_NO}/${param.EMPLID}`),
    chart4:(strm:string, class_nbr:string,emplid:string): Promise<IResponse> => requests.get(`academic/obe/get-calculated-scale4-graph/${strm}/${class_nbr}/${emplid}`),
    recapTableCol:(strm:string, class_nbr:string): Promise<IResponse> => requests.get(`academic/obe/get-calculated-recap-table-col/${strm}/${class_nbr}`),
    
}

const Common = {
    institution:(emplid: string): Promise<IResponse> => requests.get(`/common/institution/list/${emplid}`),
    institutionAuto:(emplid: string): Promise<IResponse> => requests.get(`/common/institution/list-auto/${emplid}`),
    career:(emplid: string, institution: string): Promise<IResponse> => requests.get(`/common/career/list/${emplid}/${institution}`),
    careerAuto:(emplid: string,institution: string): Promise<IResponse> => requests.get(`/common/career/list-auto/${emplid}/${institution}`),
    programByInstitution:(emplid: string, institution: string, career: string): Promise<IResponse> => requests.get(`/common/program/by-institution-career/${emplid}/${institution}/${career}`),
    semester:(institution: string, career: string): Promise<IResponse> => requests.get(`/common/semester/list/${institution}/${career}`),
    semester2:(institution: string, career: string): Promise<IResponse> => requests.get(`/common/semester/list2/${institution}/${career}`),
    semesterNext:(institution: string, career: string): Promise<IResponse> => requests.get(`/common/semester/list-next/${institution}/${career}`),
    semesterLatest:(institution: string, career: string): Promise<IResponse> => requests.get(`/common/semester/latest/${institution}/${career}`),
    semesterLatestAuto:(institution: string, career: string): Promise<IResponse> => requests.get(`/common/semester/latest-auto/${institution}/${career}`),
    semesterCheckUas:(institution: string, career: string): Promise<IResponse> => requests.get(`/common/semester/list-check-uas/${institution}/${career}`),
    profile:(token: string): Promise<IResponse> => requests.get(`/academic/account/profile/${token}`),
    menu:(emplid: string): Promise<IResponse> => requests.get(`/academic/account/menu/${emplid}`),
    menuParent:(emplid: string): Promise<IResponse> => requests.get(`/academic/account/menu-parent/${emplid}`),
    menuTree:(emplid: string): Promise<IResponse> => requests.get(`/academic/account/menu-tree/${emplid}`),
    dashboard:(level: string, emplid: string): Promise<IResponse> => requests.get(`/academic/dashboard/report/${level}/${emplid}`),
    studentresponse:(code: string, response: number): Promise<IResponse> => requests.get(`/academic/student/response/${code}/${response}`),
    
}

const NotEnrolled = {
    StudentNotEnrolledList:(param: NotEnrolledParam): Promise<IResponse> => requests.post('/academic/enrollment/search',param),
    processUpdateCallStatus:(param: any): Promise<IResponse> => requests.post('/academic/enrollment/update-call-status',param),
    callReason:(): Promise<IResponse> => requests.get(`/academic/enrollment/call-reason/`),
}

const Documents = {
    documentList:(strm: string, type: string, emplid: string, acadProg: string): Promise<IResponse> => requests.get(`/academic/document/get-doc-list/${strm}/${type}/${emplid}/${acadProg}`),
    userRole: (emplid: string) => requests.get(`/academic/document/get-user-role/${emplid}`),
    lecturerList: (emplid: string) => requests.get(`/academic/document/get-lecturer/${emplid}`),
    termList: (institution: string, career: string) => requests.get(`/academic/document/get-term/${institution}/${career}`),
    deleteDoc: (docNo: string, emplid: string) => requests.get(`/academic/document/delete-document/${docNo}/${emplid}`),
    lecturerData: (emplid: string) => requests.get(`/academic/document/get-lecturer-data/${emplid}`)
}

export default {
    StudyEvaluation,
    Common,
    StudentAttendance,
    LecturerAttendance,
    Obe,
    NotEnrolled,
    Documents
}